"use strict";import{ProgressCircle as e}from"./src/ProgressCircle.js";import{defineElement as r}from"@spectrum-web-components/base/src/define-element.js";r("sp-progress-circle",e);
//# sourceMappingURL=sp-progress-circle.js.map
